import { useEffect, useCallback } from 'react';
import { POINTSERV_STATUS_CODE_KEY } from 'shared/constants/pointserv';

const usePointservListener = (orderId, handleComplete, handleReset) => {
  const onStorage = useCallback(() => {
    const response = window.localStorage.getItem(POINTSERV_STATUS_CODE_KEY);
    // prevent re-executing with results
    window.localStorage.removeItem(POINTSERV_STATUS_CODE_KEY);

    if (response) {
      if (response === 'SUCCESS') handleComplete(orderId);
      handleReset();
    }
  }, [handleComplete, handleReset, orderId]);

  useEffect(() => {
    window.addEventListener('storage', onStorage);

    return () => {
      window.removeEventListener('storage', onStorage);
    };
  }, [onStorage]);
};

export default usePointservListener;
